import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import '../style.css'
import Institutions from './Institutions'
import Contact from './Contact'
import NetworkingCarousel from '../Ext/NetworkingCarousel'
import Header from '../Ext/Header'
import '../Animations.css'

const Home = () => {

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const animatables = document.querySelectorAll('.animatable');

      animatables.forEach(animatable => {
        const elementTop = animatable.getBoundingClientRect().top + scrollY;
        const elementBottom = elementTop + animatable.clientHeight;

        // Check if element is in the viewport
        if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
          animatable.classList.add('animated');
          animatable.classList.remove('animatable');
        } else {
          // Reset the animation when the element is out of view
          animatable.classList.remove('animated');
          animatable.classList.add('animatable');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger animation on mount

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <>
    
    {/* <div className="home-container">
      <div className="home-b1-left">
        <Typography>
        <h1>Welcome to Shiva Ganga Group</h1>
        <h3>Empowering Education, Inspiring Excellence.</h3>
        <p>At Shiva Ganga Group, we are committed to fostering educational excellence through our group of prestigious institutions. With a vision to nurture holistic development and innovation, we provide world-class education in a nurturing environment.</p>
        </Typography>
      </div>
      <div className="home-b1-right">
        <img src="./images/h-1.png" alt="Shiva Ganga Education Group" />
      </div>
    </div> */}
    
    <Header />
    


    <div className="educat-container">
      {/* Box 1: Image */}
      <div className="educat-box educat-box1 block animatable bounceInLeft">
        <img
          src="./images/h-2.png"
          alt="Educational Excellence"
          className="educat-image"
        />
      </div>
      
      {/* Box 2: Text Content */}
      <div className="educat-box educat-box2 block animatable bounceInRight">
        <p className="educat-text ">
          "At Shiva Ganga Group, we are committed to fostering educational excellence 
          through our group of prestigious institutions. With a vision to nurture holistic development 
          and innovation, we provide world-class education in a nurturing environment."
        </p>
      </div>
    </div>

    <NetworkingCarousel />



    {/* <Institutions /> */}

    <Contact />

    
    </>


  )
}

export default Home